import FAQComponent from '../../../components/FAQComponent/FAQComponent';
import AppFAQAnswer from '../../../components/FAQComponent/components/FAQAnswer/AppFAQAnswer';
import { generalPlanQuestions } from '../../../util/constants/faqContent';

const PaymentPolicyFAQ = () => {
  return (
    <FAQComponent
      title="Payment and policy FAQs"
      titleClassNames="!text-2xl mb-4 text-center md:!text-4xl"
      subtitleClassNames="text-center"
      questions={[
        generalPlanQuestions, // DO NOT USE THE OTHER QUESTIONS ANYMORE TO KEEP THINGS SIMPLE
      ]}
      itemConfig={{
        answerComponent: ({ item }) => <AppFAQAnswer answers={item.answers} />,
      }}
    />
  );
};

export default PaymentPolicyFAQ;
